import React from 'react';
import Main from '../../components/Main';
import '../../assets/styles/Global.css';

// IQSTokens Subpage of AboutUs Page

const IQSTokens = () => {
  return (
    <div>
      <Main componentList={[
        <div>
          <h6 className='top_sentence'>A unique, participative financial IQosystem</h6>
          <br/>
          <p style={{color : "#1f3864"}}>
            IQS Tokens allow all of our Exec Partners, consultants and IQosystem contributors to become shareholders of the firm and capitalize on the value created through team work.
            <br/> 
            <br/>
            IQosys runs a Token exchange which allows you to buy and sell IQS Tokens easily at a minimal transaction cost.
            <br/>
            <br/>
            A total of 500 million IQS Tokens have been created and are exchangeable on our Ethereum ERC-20 block-chain. The N Token block contract stipulates that the number of IQS Tokens is fixed. Each AD Token represents a share of equity in IQosys SAS and is eligible for dividend payments at the end of each fiscal year.
            <br/>
            <br/>
            IQosys SAS, is a company registered in France. It has 1 billion shares. Owners of IQS Tokens can exchange their tokens against IQosys Class A shares at a rate of 1:1 at any time of their choosing (see terms and conditions).
            <br/>
            <br/>
            Explore our IQS Tokens.
          </p>
          <hr className="my-custom-hr"/>
      </div>]} />
    </div>
  );
};

export default IQSTokens;